import FullscreenButton from './fullscreen-button-component';
export default FullscreenButton;
